import React from 'react';

import DiscountFlagImage from './../DiscountFlagImage';
import { deadlineForText } from './../../../../../utils';

const getPixInput = (props, i) => {
  return (
    <React.Fragment>
      <input
        type="radio"
        name="methodPayment"
        onChange={() => props.selectPaymentMethod(i)}
        checked={!!props.paymentMethods[i].selected}
        id={props.paymentMethods[i].class}
      />

      <DiscountFlagImage
        paymentMethod={props.paymentMethods[i]}
        content={
          <div>
            <h4>{props.paymentMethods[i].name}</h4>
            <span className="info-pix">{`O pagamento deve ser realizado em até ${deadlineForText(
              props.paymentMethods[i].deadline
            )} após finalizar a compra.`}</span>
          </div>
        }
        imgData={<img className='pay-me-icon' src="/assets/images/pagamento/payMeeIcon.png" alt="icone da plataforma payMee" />}
      />
    </React.Fragment>
  );
};

export default getPixInput;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/desktop/inputs/getPixInput.jsx